<template>
    <ul class="sidebar-nav">
        <li class="sidebar-item" v-for="item in visibleMenuItems" :key="item.id">
            <router-link class="sidebar-link" :to="item.url" :class="authUser.status == 1 ? 'disabled' : ''">
                <div>
                    <img :src="item.icon">
                    <span class="align-middle ml-2">{{ item.text }}</span>
                </div>
            </router-link>
        </li>
        <li class="sidebar-item">
            <a href="#" class="sidebar-link" @click.prevent="logout">
                <div>
                    <img src="@/assets/imgs/sidebar-icons/log-out.svg">
                    <span class="align-middle ml-2">Log Out</span>
                </div>
            </a>
        </li>
    </ul>
</template>
<script>
import config from '@/config'
export default {
    data() {
        return {
            // Every item is visible to all roles unless it declares its own `roles` allow-list.
            menuItems: [
                { text: 'Dashboard', icon: require('@/assets/imgs/sidebar-icons/dashboard.svg'), url: 'dashboard', roles: ['owner', 'manager', 'moderator'] },
                { text: 'Add Parcel', icon: require('@/assets/imgs/sidebar-icons/add-parcel.svg'), url: 'add-parcel', roles: ['owner', 'manager', 'moderator'] },
                { text: 'Entry Parcel List', icon: require('@/assets/imgs/sidebar-icons/entry-parcel.svg'), url: 'entry-parcel-list', roles: ['owner', 'manager', 'moderator'] },
                { text: 'Under Review Parcel', icon: require('@/assets/imgs/sidebar-icons/review-parcel.svg'), url: 'under-review-parcel-list', roles: ['owner', 'manager', 'moderator'] },
                { text: 'Total Parcel List', icon: require('@/assets/imgs/sidebar-icons/parecl-list.svg'), url: 'total-parcel-list', roles: ['owner', 'manager', 'moderator'] },
                { text: 'Pickup Request List', icon: require('@/assets/imgs/sidebar-icons/pickup-request.svg'), url: 'pickup-request-list', roles: ['owner', 'manager', 'moderator'] },
                { text: 'Price Changed List', icon: require('@/assets/imgs/sidebar-icons/payment-request.svg'), url: 'price-changed-list', roles: ['owner', 'manager', 'moderator'] },
                { text: 'Payment Request List', icon: require('@/assets/imgs/sidebar-icons/payment-request.svg'), url: 'payment-request-list', roles: ['owner', 'manager', 'moderator'] },
                { text: 'Payment Received List', icon: require('@/assets/imgs/sidebar-icons/payment-request.svg'), url: 'payment-received-list', roles: ['owner', 'manager'] },
                { text: 'Return List', icon: require('@/assets/imgs/sidebar-icons/return-request.svg'), url: 'return-list', roles: ['owner', 'manager', 'moderator'] },
                // { text: 'Parcel Statistics', icon: require('@/assets/imgs/sidebar-icons/parcel-statistics.svg'), url: 'parcel-statistics' },
                { text: 'Coverage Area', icon: require('@/assets/imgs/sidebar-icons/coverage-area.svg'), url: 'covarage-area', roles: ['owner', 'manager', 'moderator'] },
                { text: 'Track Parcel', icon: require('@/assets/imgs/sidebar-icons/track-percel.svg'), url: 'track-parcel', roles: ['owner', 'manager', 'moderator'] },
                { text: 'Pricing Calculator', icon: require('@/assets/imgs/sidebar-icons/price-calculator.svg'), url: 'pricing-calculator', roles: ['owner', 'manager', 'moderator'] },
                { text: 'Support / Complain', icon: require('@/assets/imgs/sidebar-icons/support.svg'), url: 'complain', roles: ['owner', 'manager', 'moderator'] },
                { text: 'Fraud Check', icon: require('@/assets/imgs/sidebar-icons/fraud-check.svg'), url: 'fraud-check', roles: ['owner', 'manager', 'moderator'] },
                { text: 'Stores', icon: require('@/assets/imgs/sidebar-icons/fraud-check.svg'), url: 'stores', roles: ['owner', 'manager', 'moderator'] },
                { text: 'Teams', icon: require('@/assets/imgs/sidebar-icons/support.svg'), url: 'team', roles: ['owner','manager'] },
                { text: 'API', icon: require('@/assets/imgs/sidebar-icons/api.svg'), url: 'api', roles: ['owner', 'manager', 'moderator'] },
                { text: 'Developer API', icon: require('@/assets/imgs/sidebar-icons/api.svg'), url: 'developer-api', roles: ['owner', 'manager', 'moderator'] },
                // { text: 'Log Out', icon: require('@/assets/imgs/sidebar-icons/log-out.svg'), url: 'logout' },
            ],
        };
    },
    computed: {
        authUser: function () {
            return this.$store.state.authUser
        },
        visibleMenuItems: function () {
            return this.menuItems.filter(item => !item.roles || item.roles.includes(this.authUser.role))
        }
    },
    methods:{
        logout(){
            this.$router.push('/');
            config.postData('/logout')
            .then(() => {
                localStorage.removeItem('merchantAccessToken')          
                this.$store.dispatch('setAuthUser', '')
                this.$store.dispatch('setAccountDetails', '')
                this.$toast.success({
                    title: 'Success',
                    message: 'Logout successfully',
                    color: '#218838'
                })
            })      
        }
    }
};
</script>